export const inspectTable = [
  {
    content: "유해·위험한 기계·기구 등의 방호조치 등 (법 제80조)",
    isChecked: "",
  },
  {
    content: "기계․기구 등 대여자 조치 (법 제81조)",
    isChecked: "",
  },
  {
    content: "유해·위험한 기계·기구·설비 등의 안전인증 (법 제83조~제85조, 제87조)",
    isChecked: "",
  },
  {
    content: "유해·위험한 기계·기구·설비 등의 자율안전확인의 신고 (법 제89조, 제90조, 제92조)",
    isChecked: "",
  },
  {
    content: "유해·위험기계등에 대한 안전검사, 안전검사합격증명서 부착, 안전검사대상기계 등의 사용 금지, 자율검사프로그램 (법 제93조~제95조, 제98조)",
    isChecked: "",
  },
];
